<template>
  <div class="items-center flex">
    <div class="flex items-center px-16 py-4 rounded-16px justify-center">
      <div class="w-full">
        <div class="w-full">
          <div class="flex items-center gap-4 ml-4">
            <img src="@/assets/images/BA 5.png" alt="image" class="w-24" />
            <h2
              class="lg:font-semibold md:font-semibold font-bold lg:text-3xl md:text-2xl text-xl"
            >
              Heads Up, here's a list of all the standard features we offer with
              the suite that you've selected.
            </h2>
          </div>
        </div>
        <div class="flex flex-wrap mt-6 pl-12">
          <h2
            v-for="suite in allSuiteData"
            :key="suite._id"
            class="fsize14 px-5 py-2 text-warning rounded-full text-center light-chipswarning m-2 cursor-pointer"
            @click="selectSuite(suite)"
            :class="{
              'bg-primary text-white': suite._id === selectedSuite._id,
            }"
          >
            {{ suite.name }} Standard Features
          </h2>
        </div>
        <div class="primaryborder-set rounded-12px ml-12 mt-4">
          <ul class="scrollbar35">
            <li
              v-for="(page, index) in selectedSuite.pages"
              :key="page._id"
              class="fsiz12 p-3 lightbottom-b cursor-pointer"
            >
              {{ index + 1 }}. {{ page.page }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return { allSuiteData: {}, selectedSuite: {} };
  },
  methods: {
    selectSuite(value) {
      this.selectedSuite = value;
      console.log(this.selectedSuite, "methods");
    },
  },
  watch: {
    selectedSuiteData(val) {
      this.allSuiteData = this.selectedSuiteData;
    },
  },
  mounted() {
    this.allSuiteData = this.selectedSuiteData;
    this.$store.commit("scope/SET_CURRENT_PAGE", "customFunctionalityPage");
    this.selectedSuite = this.selectedSuiteData[0];
  },
  computed: {
    ...mapState("scope", ["selectedSuiteData"]),
  },
};
</script>
<style>
.input-effect {
  border: 0;
  padding: 7px 0;
  border-bottom: 3px solid #ccc;
}

.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
</style>
